module.exports = __webpack_public_path__ + "static/sec2-leaves-532a6c67338d7bd0bc7b23d54baa6811.png";